export const TRANSLATION_LOGIN_PENDING = 'TRANSLATION_LOGIN_PENDING';
export const TRANSLATION_LOGIN_IN_PROCESS = 'TRANSLATION_LOGIN_IN_PROCESS';
export const TRANSLATION_LOGIN_FAILED = 'TRANSLATION_LOGIN_FAILED';
export const TRANSLATION_LOGIN_SUCCESS = 'TRANSLATION_LOGIN_SUCCESS';
export const TRANSLATION_LOGIN_LANGUAGES_SUCCESS =
  'TRANSLATION_LOGIN_LANGUAGES_SUCCESS';
export const TRANSLATION_LOGIN_DEFAULT_LANGUAGE_SUCCESS =
  'TRANSLATION_LOGIN_DEFAULT_LANGUAGE_SUCCESS';
